/**
 * Application configuration
 * All environment variables should be explicitly defined
 */

// Define all required environment variables
const requiredConfig = {
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
  },
  functions: {
    region: import.meta.env.VITE_FUNCTIONS_REGION
  }
};

// Optional configuration with explicit checks
const optionalConfig = {
  emulators: {
    enabled: import.meta.env.VITE_USE_EMULATORS === 'true',
    auth: {
      url: import.meta.env.VITE_AUTH_EMULATOR_URL
    },
    firestore: {
      host: import.meta.env.VITE_FIRESTORE_EMULATOR_HOST,
      port: import.meta.env.VITE_FIRESTORE_EMULATOR_PORT ? 
        parseInt(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT) : undefined
    },
    functions: {
      host: import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST,
      port: import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT ? 
        parseInt(import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT) : undefined
    }
  }
};

// Validate required configuration
const validateConfig = () => {
  const errors = [];
  
  // Check Firebase config
  Object.entries(requiredConfig.firebase).forEach(([key, value]) => {
    if (!value) {
      errors.push(`VITE_FIREBASE_${key.toUpperCase().replace(/([A-Z])/g, '_$1').slice(1)}`);
    }
  });
  
  // Check functions region
  if (!requiredConfig.functions.region) {
    errors.push('VITE_FUNCTIONS_REGION');
  }
  
  // Check emulator config if emulators are enabled
  // Only functions emulator is required — Firestore/Auth emulators are optional
  if (optionalConfig.emulators.enabled) {
    if (!optionalConfig.emulators.functions.host || !optionalConfig.emulators.functions.port) {
      errors.push('VITE_FUNCTIONS_EMULATOR_HOST', 'VITE_FUNCTIONS_EMULATOR_PORT');
    }
  }
  
  if (errors.length > 0) {
    throw new Error(
      `Missing required environment variables:\n${errors.join('\n')}\n\n` +
      'Please check your .env.local file and ensure all required variables are set.'
    );
  }
};

// Validate on import
validateConfig();

// Export validated configuration
export const config = {
  ...requiredConfig,
  ...optionalConfig,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD
};

export default config;